import { ProductUtil } from '~shared/utils/product.util';
import { GaTrackingStringConstantEnum } from '~shared/modules/ga-tracking/constants';

export function getBlackWeekPaylodProperties(isBlackDealsEnabled: boolean, product) {
  const isBlackDealProduct = isBlackDealsEnabled && ProductUtil.isBlackDealProduct(product.tags);
  const isLimitedStock = !!product.bestOffer && ProductUtil.isLimitedStock(product.bestOffer.quantity);

  return {
    dimension51: isBlackDealProduct ?
      GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No,
    dimension52: isBlackDealProduct && isLimitedStock ?
      GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No,
  };
}

export function getBlackWeekPaylodPropertiesGA4(isBlackDealsEnabled: boolean, product) {
  const isBlackDealProduct = isBlackDealsEnabled && ProductUtil.isBlackDealProduct(product.tags);

  return {
    item_black_deal_label: isBlackDealProduct ?
      GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No
  };
}